// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","arrow":"_1yLvfBrWMaZoZBh_","icon":"v6bs-DFvifMTKNTy","familyIcon":"_30HIKb1ThnWoe3wd"};